import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDebouncedCallback } from 'use-debounce';
import useAttachments from '../useAttachments';
import { UseDataProps } from './types';
import { debounceTime } from '50.quickConnect.Fields/const';
import { AllFieldValueTypes, AttachmentItemData, PhotoDesc } from '90.quickConnect.Models/models';

const useData = (
  onlyImage: boolean,
  photoDesc: PhotoDesc,
  updateDeclaration: (updatedFieldFullPathId: string, newValue: AllFieldValueTypes) => void,
): UseDataProps => {
  // On récupère la translation
  const { t } = useTranslation('declaration');
  const { fullPathId, value } = photoDesc;
  const [localValue, setLocalValue] = useState((value as AttachmentItemData[]) ?? []);

  // On définit les callbacks
  const updateGlobalState = useCallback(() => {
    updateDeclaration(fullPathId, localValue);
  }, [fullPathId, localValue, updateDeclaration]);

  const debouncedUpdateGlobalState = useDebouncedCallback(() => {
    updateGlobalState();
  }, debounceTime);

  const updateState = useCallback(() => {
    debouncedUpdateGlobalState();
  }, [debouncedUpdateGlobalState]);

  const { handleFileDrop, handleFileDelete, handleFilePreview } = useAttachments(
    onlyImage,
    localValue,
    setLocalValue,
    t,
    photoDesc,
    debouncedUpdateGlobalState,
  );
  // On retourne les valeurs à la vue
  return {
    t,
    localValue,
    setLocalValue,
    updateState,
    handleFileDrop,
    handleFileDelete,
    handleFilePreview,
  };
};

export default useData;
